var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-team-container"},[_vm._v(" You have not been added to a team. "),_c('br'),_vm._v(" Please ask your administrator to add you. "),_c('br'),_c('br'),_vm._v(" Alternatively, contact "),_c('EmailLink',{attrs:{"subject":"Account Support: No Team"}}),_vm._v(" for help. ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }